import { SxProps } from "@mui/material";

export const sxTextMenu: SxProps = { 
  fontFamily: "Montserrat-Bold", 
  padding: "0", 
  color: "var(--secondary-medium-grey)",
  fontSize: "var(--font-size-small)", 
};

export const sxButtonMobileMenu: SxProps = { 
  fontFamily: "Montserrat-Regular", 
  padding: "0",
  fontSize: "var(--font-size-base)", 
};